import { Observable, getRequestIdentifier, type FetchFunction } from 'relay-runtime';

import { shouldBlockRequest, markRequestBlocked, markSSRTestQueryFired } from './ssrGuards.ts';

// Analogous to Apollo SSRTestLink - counts queries fired for E2E test parity
export const createSSRTestFetch = (baseFetch: FetchFunction): FetchFunction => {
	return (request, variables, cacheConfig, uploadables) => {
		markSSRTestQueryFired(request.name);
		return baseFetch(request, variables, cacheConfig, uploadables);
	};
};

// Analogous to Apollo SSRLink - applies SSR guards and blocking logic
export const createSSRFetch = (baseFetch: FetchFunction): FetchFunction => {
	return (request, variables, cacheConfig, uploadables) => {
		// Block after SSR if required according to the current SSR guard mode
		if (
			shouldBlockRequest({
				operationName: request.name,
				operationKind: request.operationKind,
				blockedAction: 'pending_forever',
			})
		) {
			markRequestBlocked(getRequestIdentifier(request, variables));
			return Observable.create(() => {
				// Don't call observer.complete() - keep Suspense in loading state
				// This matches Apollo's behavior where blocked queries stay in loading
				return () => {};
			});
		}

		// Delegate to base fetch
		return baseFetch(request, variables, cacheConfig, uploadables);
	};
};
